import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../../HttpClient";

export const CreatePMPlan = createAsyncThunk("createPMplan", async (data) => {
    try {
        const postAllData = await httpClient.post(`/maintenanceapp/pm/plan`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in postAllData", response);
        return {
            response,
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message;

            // Check if 'Message' is an object (e.g., validation errors)
            if (typeof backendMessage === 'object' && backendMessage !== null) {
                const validationErrors = Object.entries(backendMessage)
                    .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
                    .join("; ");

                throw new Error(`Validation failed: ${validationErrors}`);
            } else {
                // Handle the case where 'Message' is a string or undefined
                const message = backendMessage || "An error occurred while processing the request";
                throw new Error(message);
            }
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const UpdatePMPlan = createAsyncThunk("UpdatePMPlan", async (data) => {
    try {
        const postAllData = await httpClient.put(`/maintenanceapp/pm/plan`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in Update Plan", response);
        return {
            response,
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const CreatePMCheckpoints = createAsyncThunk("PMCheckpoints", async (data) => {
    try {
        const postAllData = await httpClient.post("/maintenanceapp/pm/checkpoint", data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in creating PM checkpoints", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getPMCheckpoints = createAsyncThunk("getPMCheckpoints", async (plan_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/checkpoint?plan_id=${plan_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting PM checkpoints", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);
export const getPMCheckpointById = createAsyncThunk("getPMCheckpointById", async (checkpoint_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/checkpoint?checkpoint_id=${checkpoint_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting PM checkpoint By Id", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const getAllPM_plans = createAsyncThunk("getPM-plans", async () => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/plan/overview?start=0&limit=20`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all PM plans", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getPM_planbyId = createAsyncThunk("getPM-planbyId", async (plan_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/plan?plan_id=${plan_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all PV plans", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);
export const getPM_planbyAssetId = createAsyncThunk("getPM_planbyAssetId", async (asset_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/plan?asset_ids=${asset_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all PV plans", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const CreatePMLogs = createAsyncThunk("PMlogs", async (data, { rejectWithValue }) => {
    try {
        const postAllData = await httpClient.post("/maintenanceapp/pm/logs", data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in creating PM logs", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});
//      catch (error) {
//         console.log("Error:", error)
//         throw error;
//     }
// }
// );

export const updatePMLogs = createAsyncThunk("updatePMLogs", async (data, { rejectWithValue }) => {
    try {
        const postAllData = await httpClient.put("/maintenanceapp/pm/logs", data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in creating PM logs", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const getAllPM_logs = createAsyncThunk("getPM-logs", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/logs/overview${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all PM logs", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getPMLogByPlanId = createAsyncThunk("singlePMLog", async ({ plan_id, plan_date }) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/logs?plan_id=${plan_id}&plan_date=${plan_date}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getPMNgReviews = createAsyncThunk("getPMNgReviews", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/pm/ng_review${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const getPM_Reports = createAsyncThunk("getPM_Reports", async ({ asset_id, freq, fromTime, toTime }) => {
    try {
        // http://localhost:8080/maintenanceapp/pm/stats?freq=day&from_time=2024-09-08T01:00:00&to_time=2024-09-25T01:00:00&asset_ids=770657CCB5AF4A86853FC138EBF5CE7E
        const getAllData = await httpClient.get(`/maintenanceapp/pm/stats?asset_ids=${asset_id}&freq=${freq}&from_time=${fromTime}&to_time=${toTime}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const ResolvePMNgReviews = createAsyncThunk("ResolvePMNgReviews", async (data) => {
    try {
        const postAllData = await httpClient.post(`/maintenanceapp/pm/ng_review`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in ResolvePMNgReviews", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const ApprovePMNgReviews = createAsyncThunk("ApprovePMNgReviews", async (data) => {
    try {
        const postAllData = await httpClient.put(`/maintenanceapp/pm/ng_review`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in ResolvePMNgReviews", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const ApproveCheckSheet = createAsyncThunk("ApproveCheckSheet", async (data) => {
    try {
        const postAllData = await httpClient.post(`/maintenanceapp/pm/logs/approve`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        console.log("success in ResolvePMNgReviews", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const deletePMCheckpoint = createAsyncThunk("deletePMCheckpoint", async (checkpoint_id) => {
    try {
        const postAllData = await httpClient.delete(`maintenanceapp/pm/checkpoint?checkpoint_id=${checkpoint_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        const result = response.Result;
        const message = response.Message;
        console.log("success in ResolvePMNgReviews", response);
        return {
            result,
            StatusCode,
            message
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const PMuploadFile = createAsyncThunk("PMuploadFile", async (data) => {
    try {
        const postAllData = await httpClient.post(`/maintenanceapp/pm/logs`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        // const result = response.Result;
        console.log("success in PV Logs", response);
        return {
            StatusCode,
            response
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


const CreatePMPlanSlice = createSlice({
    name: "CreatePMPlanSlice",
    initialState: {
        loading: false,
        error: null,
        response: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPMCheckpoints.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getPMCheckpoints.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload.result;
            })
            .addCase(getPMCheckpoints.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        // builder
        //     .addCase(CreateDefaultCheckpoints.pending, (state, action) => {
        //         state.loading = true;
        //     })
        //     .addCase(CreateDefaultCheckpoints.fulfilled, (state, action) => {
        //         state.loading = false;
        //         state.response = action.payload.result;
        //     })
        //     .addCase(CreateDefaultCheckpoints.rejected, (state, action) => {
        //         state.loading = false;
        //         state.error = action.payload;
        //     });
    },
})


export default CreatePMPlanSlice.reducer;